








import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconTypeformGroup extends Vue {
    @Prop({ type: Number, default: 22 }) readonly size!: number
}
